import { render, staticRenderFns } from "./Produksi.vue?vue&type=template&id=33bf9cce&scoped=true&"
import script from "./Produksi.vue?vue&type=script&lang=js&"
export * from "./Produksi.vue?vue&type=script&lang=js&"
import style0 from "./Produksi.vue?vue&type=style&index=0&id=33bf9cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf9cce",
  null
  
)

export default component.exports